<template>
  <div class="w-full flex">
    <div class="w-3/12 px-2">
      <div class="w-full border rounded py-2">
        <el-menu default-active="1" class="el-menu-vertical-demo">
          <el-menu-item index="1" @click="menuName = 'user'" class="font-bold">
            <i class="el-icon-user"></i>
            <span>User</span>
          </el-menu-item>
          <el-menu-item index="2" @click="menuName = 'role'" class="font-bold">
            <i class="el-icon-set-up"></i>
            <span>Role</span>
          </el-menu-item>
          <el-menu-item index="3" @click="menuName = 'sync'" class="font-bold">
            <i class="el-icon-refresh"></i>
            <span>Sync Data</span>
          </el-menu-item>
          <el-menu-item index="4" @click="menuName = 'log'" class="font-bold">
            <i class="el-icon-tickets"></i>
            <span>Audit Log</span>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="w-9/12 px-2">
      <div class="p-4 border rounded">
        <UserList v-if="menuName === 'user'" />
        <RoleList v-else-if="menuName === 'role'" />
        <SyncList v-else-if="menuName === 'sync'" />
        <LogList v-else />
      </div>
    </div>
  </div>
</template>

<script>
import UserList from '@/pages/master/user/List'
import RoleList from '@/pages/master/role/List'
import SyncList from '@/pages/master/sync-data/List'
import LogList from '@/pages/master/auditLog/List'

export default {
  components: {
    UserList,
    RoleList,
    SyncList,
    LogList
  },
  data() {
    return {
      accordionActivityName: '1',
      menuName: 'user'
    }
  },
  mounted() {
    if (!this.$store.state.auth.isAdmin) {
      alert("You aren't authorized to access this page")
      this.$router.go(-1)
    }
  }
}
</script>
